import React, { FC } from "react";
import { BasicDialog } from "@src/views/components/modals/BasicDialog";
import { BasicDialogContainer } from "@src/views/components/modals/BasicDialogContainer";
import { Align, SemanticUIColor, Size } from "@src/types";
import { DashPage } from "../../dash/DashContainerPage";
import { Icon } from "semantic-ui-react";
import { Grid, Cell } from "styled-css-grid";
import "./DashDialogs.scss";

interface Props {
    page: DashPage;
    onConfirm: (pageId: string) => void;
    onClose: () => void;
}

const DeleteDashPageDialog: FC<Props> = ({ page, onConfirm, onClose }) => {
    return (
        <BasicDialog
            showCancelButton={true}
            showSubmitButton={true}
            submitLabel="Delete Page"
            submitColor={SemanticUIColor.RED}
            onCancel={onClose}
            onSubmit={() => {
                onConfirm(page.id);
                onClose();
            }}
            controlAlign={Align.CENTER}
            className="no-padding dash-dialog"
        >
            <BasicDialogContainer
                title="Delete Dashboard Page"
                titleColor={SemanticUIColor.PURPLE}
                contentPadding={[Size.MD, Size.MD, Size.LG, Size.MD]}
                onClose={onClose}
            >
                <Grid>
                    <Cell width={16} className="dash-dialog__warning-icon">
                        <Icon name="warning circle" size="huge" color="red" />
                    </Cell>

                    <Cell width={16} className="dash-dialog__message">
                        Are you sure you want to delete the page:
                    </Cell>

                    <Cell width={16} className="dash-dialog__page-name">
                        {page.name}
                    </Cell>

                    <Cell width={16} className="dash-dialog__page-description">
                        {page.description}
                    </Cell>

                    <Cell width={16} className="dash-dialog__warning-text">
                        This action cannot be undone.
                    </Cell>
                </Grid>
            </BasicDialogContainer>
        </BasicDialog>
    );
};

export { DeleteDashPageDialog };
